import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuCaratWeight } from '../../SbSharedRefineMenu/SbSharedRefineMenuCaratWeight/SbSharedRefineMenuCaratWeight';

export const SbRespRefineMenuFilterCaratWeightComponent = props => (
    <SbSharedRefineMenuCaratWeight {...props} />
);

export const SbRespRefineMenuFilterCaratWeight = createFragmentContainer(
    SbRespRefineMenuFilterCaratWeightComponent,
    {
        searchBrowse: graphql`
            fragment SbRespRefineMenuFilterCaratWeight_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuCaratWeight_searchBrowse
            }
        `,
    }
);
